module.exports = __webpack_public_path__ + "static/media/ico_tint_alt_04.f37ce659.svg";